document.addEventListener("DOMContentLoaded", function () {
    const applianceSelect = document.getElementById("appliance");
    const customWattageGroup = document.getElementById("custom-wattage-group");
    const calculateBtn = document.getElementById("calculate-btn");
    const resultsDiv = document.getElementById("results");

    // Show/hide custom wattage field
    applianceSelect.addEventListener("change", function () {
        if (this.value === "custom") {
            customWattageGroup.style.display = "block";
        } else {
            customWattageGroup.style.display = "none";
        }
    });

    // Calculate button click handler
    calculateBtn.addEventListener("click", function () {
        calculateCost();
    });

    // Also calculate when pressing Enter in input fields
    document.getElementById("usage").addEventListener("keypress", function (e) {
        if (e.key === "Enter") calculateCost();
    });

    document.getElementById("price").addEventListener("keypress", function (e) {
        if (e.key === "Enter") calculateCost();
    });

    document
        .getElementById("custom-wattage")
        .addEventListener("keypress", function (e) {
            if (e.key === "Enter") calculateCost();
        });

    function calculateCost() {
        // Get appliance wattage
        let wattage;
        if (applianceSelect.value === "custom") {
            wattage = parseFloat(document.getElementById("custom-wattage").value);
            if (isNaN(wattage) || wattage <= 0) {
                alert("Please enter a valid wattage");
                return;
            }
        } else {
            wattage = parseFloat(applianceSelect.value);
        }

        // Get usage
        const usageInput = parseFloat(document.getElementById("electricity-usage").value);
        if (isNaN(usageInput) || usageInput < 0) {
            alert("Please enter a valid usage value");
            return;
        }

        const usageUnit = document.getElementById("usage-unit").value;
        let usageHours;
        if (usageUnit === "minutes") {
            usageHours = usageInput / 60;
        } else {
            usageHours = usageInput;
        }

        // Get price
        const price = parseFloat(document.getElementById("price").value);
        if (isNaN(price) || price < 0) {
            alert("Please enter a valid electricity price");
            return;
        }

        // Calculate kWh per day
        const kWhPerDay = (wattage * usageHours) / 1000;

        // Calculate costs
        const costPerHour = (wattage / 1000) * price;
        const costPerDay = kWhPerDay * price;
        const costPerMonth = costPerDay * 30;
        const costPerYear = costPerDay * 365;

        // Display results
        document.getElementById("cost-hour").textContent =
            "$" + costPerHour.toFixed(2);
        document.getElementById("cost-day").textContent =
            "$" + costPerDay.toFixed(2);
        document.getElementById("cost-month").textContent =
            "$" + costPerMonth.toFixed(2);
        document.getElementById("cost-year").textContent =
            "$" + costPerYear.toFixed(2);
        document.getElementById("kwh-day").textContent = kWhPerDay.toFixed(2);

        // Show results with animation
        resultsDiv.style.display = "block";
    }
});
document
    .getElementById("calculateButton")
    .addEventListener("click", async function () {
        const length = parseFloat(document.getElementById("lighting-length").value);
        const width = parseFloat(document.getElementById("lighting-width").value);
        const height = parseFloat(document.getElementById("lighting-height").value);
        const lightType = document.getElementById("lightType").value;
        const usage = document.getElementById("usage").value;

        const lightLumens = {
            "100-adjustable": 14000,
            "150-adjustable": 21000,
            "200-adjustable": 28000,
            "240-adjustable": 33600,
            "400-adjustable": 60000,
            "150-hb-black": 24000,
            "150-hb-white": 24000,
            "200-hb-black": 32000,
            "200-hb-white": 32000,
            "240-hb-black": 36000,
            "240-hb-white": 36000,
            "300-hb": 42000,
            "150-super": 24000,
            "200-super": 32000,
            "100-eco": 11000,
            "150-eco": 16500,
            "150-ufo": 16500,
            "130-linear": 19500,
            "210-linear": 31500,
            "300-linear": 45000,
        };

        const luxValues = {
            "Bedroom": 130,
            "Living Room": 130,
            "Kitchen": 300,
            "Study": 450,
            "Industrial": 450,
            "Factory": 450,
            "Bathroom": 300,
            "Office Work Area": 300,
            "Conference Room": 300,
            "Reception Area": 200,
            "Retail Stores": 650,
            "Restaurants": 80,
            "Warehouse": 200,
            "General Manufacturing": 300,
            "Fine Work Inspection": 700,
            "Assembly Line": 450,
            "Classrooms": 300,
            "Laboratories": 700,
            "Hospital Wards": 200,
            "Operating Rooms": 1500,
            "Parking Lots": 100,
            "Sidewalks": 130,
            "Sports Fields": 700,
        };

        if (
            isNaN(length) ||
            length <= 0 ||
            isNaN(width) ||
            width <= 0 ||
            isNaN(height) ||
            height <= 0
        ) {
            document.getElementById("lighting-result").innerText =
                "Please enter valid dimensions.";
            return;
        }

        const lightChoice = document.getElementById("lightType").value;
        const usageChoice = document.getElementById("usage").value;

        try {
            // 调用API获取lightsNeeded
            const apiUrl = `https://stock.romanso-led.com/api/lights/calculate?length=${length}&width=${width}&height=${height}`;
            const response = await fetch(apiUrl);

            if (!response.ok) {
                throw new Error(`API request failed with status ${response.status}`);
            }

            const result = await response.json();

            // test
            // 解析API返回的数据
            const layoutStr = result.data.layout; // "5 x 5"
            const spacingStr = result.data.spacing; // "16.0 x 18.0"
            const scale = result.data.scale || 5; // 使用API返回的scale，默认为5

            // 解析布局字符串 "5 x 5" -> [5, 5]
            const layout = layoutStr.split('x').map(num => parseInt(num.trim()));

            // 解析间距字符串 "16.0 x 18.0" -> [16.0, 18.0]
            const spacing = spacingStr.split('x').map(num => parseFloat(num.trim()));

            // 根据API返回的数据格式解析
            let lightsNeeded;
            let apiLayoutInfo = "";

            if (result.success && result.data) {
                // 从API返回的数据中获取灯具数量
                lightsNeeded = result.data.total_lights;

                apiLayoutInfo = `Layout: ${result.data.layout} <br> Spacing: ${result.data.spacing} ft <br> ${result.data.suggestion}`;

                // console.log("API response:", result);
                const layout_container = document.getElementById('layout-container');
                const width = layout[0] * spacing[0] * scale;
                const height = layout[1] * spacing[1] * scale;

                layout_container.style.width = `${width}px`;
                layout_container.style.height = `${height}px`;
                
                // 清除之前的内容（点和标签）
                layout_container.innerHTML = '';

                for (let i = 0; i < layout[0]; i++) {
                    for (let j = 0; j < layout[1]; j++) {
                        const point = document.createElement('div');
                        point.className = 'light-point';

                        const x = (i + 0.5) * spacing[0] * scale;
                        const y = (j + 0.5) * spacing[1] * scale;

                        point.style.left = `${x}px`;
                        point.style.top = `${y}px`;
                        point.style.display = `block`;

                        layout_container.appendChild(point);
                    }
                }

                // Add labels for spacing from edges
                addLabel(layout_container, spacing[0] * scale, 0, spacing[0].toFixed(2), false, true);
                addLabel(layout_container, 0, spacing[1] * scale, spacing[1].toFixed(2), true);

                function addLabel(layout_container, x, y, text, vertical = false, horizontal = false) {
                    const label = document.createElement('div');
                    label.className = 'layout-label';
                    label.textContent = `${text}`;

                    if (vertical) {
                        label.style.left = `${parseFloat(x)}px`;
                        label.style.top = `${parseFloat(y)}px`;
                    } else if (horizontal) {
                        label.style.left = `${parseFloat(x) - 10}px`;
                        label.style.top = `${parseFloat(y)}px`;
                    }

                    layout_container.appendChild(label);
                }
            } else {
                throw new Error("API returned unsuccessful or invalid data");
            }

            // 显示结果
            document.getElementById("lighting-result").innerHTML =
                `Number of lights needed: <strong>${lightsNeeded}</strong><br>` +
                (apiLayoutInfo ? `${apiLayoutInfo}` : "");

            // 显示产品链接按钮
            const productLinkButton = document.getElementById("productLinkButton");
            productLinkButton.style.display = "block";

            // 设置产品链接
            const productLinks = {
                "100-adjustable": "https://ggjia-led.com/products/high-bay-led-lights-100w",
                "150-adjustable": "https://ggjia-led.com/products/high-bay-led-lights-150w",
                "200-adjustable": "https://ggjia-led.com/products/high-bay-led-lights-200w",
                "240-adjustable": "https://ggjia-led.com/products/high-bay-led-lights-240w",
                "300-adjustable": "https://ggjia-led.com/products/high-bay-led-lights-300w",
                "400-adjustable": "https://ggjia-led.com/products/high-bay-led-lights-400w",
                "150-hb-black": "https://ggjia-led.com/products/ufo-led-high-bay-light-150w",
                "200-hb-black": "https://ggjia-led.com/products/ufo-high-bay-lights-200w",
                "240-hb-black": "https://ggjia-led.com/products/ufo-led-high-bay-light-240w",
                "300-hb-black": "https://ggjia-led.com/products/led-warehouse-lighting",
                "150-hb-white": "https://ggjia-led.com/products/ufo-led-high-bay-light-150w",
                "200-hb-white": "https://ggjia-led.com/products/ufo-high-bay-lights-200w",
                "240-hb-white": "https://ggjia-led.com/products/ufo-led-high-bay-light-240w",
                "130-linear": "https://ggjia-led.com/products/led-linear-high-bay-shop-lights",
                "210-linear": "https://ggjia-led.com/products/linear-high-bay-shop-light",
                "300-linear": "https://ggjia-led.com/products/led-linear-high-bay-lights",
                "400-linear": "https://ggjia-led.com/products/400w-led-linear-high-bay-light",
                "100-eco": "https://ggjia-led.com/products/low-bay-led-lights-100w",
                "150-eco": "https://ggjia-led.com/products/low-bay-led-lights-100w?variant=43845142151210",
                "200-eco": "https://ggjia-led.com/products/low-bay-led-lights-100w?variant=43845142249514",
            };

            if (productLinks && productLinks[lightType]) {
                productLinkButton.href = productLinks[lightType];
                productLinkButton.onclick = function () {
                    window.location.href = productLinks[lightType];
                };
            }

        } catch (error) {
            console.error("Error fetching data from API:", error);

            // API调用失败时使用原来的计算逻辑
            const volume = length * width;
            const maxLux = luxValues[usageChoice];
            const totalLumensNeeded = (volume * maxLux) / 10;
            const lumensPerLight = lightLumens[lightChoice];
            let lightsNeeded = Math.ceil(totalLumensNeeded / lumensPerLight);

            // 应用高度修正因子
            const lightsFactor = {
                10: 1.1,
                15: 1.2,
                20: 1.3,
                25: 1.4,
                30: 1.5,
                35: 1.6,
                40: 1.7,
                45: 1.8,
            };

            const threshold = Object.keys(lightsFactor).find(
                (key) => height >= key && height < parseInt(key) + 5
            );
            if (threshold) {
                lightsNeeded = Math.ceil(lightsNeeded * lightsFactor[threshold]);
            }

            // 素数检查逻辑
            function isPrime(num) {
                if (num <= 1) return false;
                if (num === 2) return true;
                for (let i = 2; i <= Math.sqrt(num); i++) {
                    if (num % i === 0) return false;
                }
                return true;
            }

            if (isPrime(Math.ceil(lightsNeeded))) {
                lightsNeeded += 1;
            }

            document.getElementById("lighting-result").innerHTML =
                `Number of lights needed: <strong>${lightsNeeded}</strong><br>` +
                `<span style="color: #666; font-size: 0.9em;">(Using fallback calculation)</span>`;
        }
    });